import { AppWindow } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { UserMenu } from "./UserMenu";
import { useNavigate } from "react-router-dom";


export function AppSidebar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <div className="w-full bg-white border-b border-slate-200">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2" >
          <span  onClick={() => navigate(`/`)}>
          <img 
              src="/uploads/fd28515a-f664-4e3e-8427-e490fdd4358c.png" 
              alt="Pageflo Logo" 
              className="h-8"
            />
          </span>
        </div>
        <UserMenu />
      </div>
    </div>
  );
}